import { render, staticRenderFns } from "./secondindex.vue?vue&type=template&id=0d8d3028&scoped=true&"
import script from "./secondindex.vue?vue&type=script&lang=js&"
export * from "./secondindex.vue?vue&type=script&lang=js&"
import style0 from "./secondindex.vue?vue&type=style&index=0&id=0d8d3028&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d3028",
  null
  
)

export default component.exports